/*
 * Delete-address.ts
 * Description: Includes the declaration of a function
 * for deleting user addresses
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Deleting a user address
 *
 * @param {Number} id - id of an address
 * @return {Object} Promise - when the request is resolved
 */
export function deleteAddress(id: number) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'addresses/' + id,
            method: 'delete',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
